import React from 'react';
import { Badge } from '@ncoder/ui';

interface TestCategoryItemProps {
  label: string;
  status: 'passed' | 'needs-work';
}

export const TestCategoryItem: React.FC<TestCategoryItemProps> = ({
  label,
  status,
}) => {
  return (
    <div className="flex justify-between text-sm">
      <span>{label}</span>
      <Badge variant={status === 'passed' ? 'default' : 'secondary'}>
        {status === 'passed' ? 'Passed' : 'Needs Work'}
      </Badge>
    </div>
  );
};
